import { useCallback } from 'react';
import { useIntl } from 'react-intl';

interface Props {
  status: string;
}

export const useStatusOptions = () => {
  const { formatMessage } = useIntl();

  const getStatus = useCallback(
    ({ status }: Props) => {
      const statusOptions = [
        {
          id: '1',
          label: formatMessage({
            id: 'status.active',
            defaultMessage: 'Aktiv',
          }),
          value: 'active',
          style: 'bg-green-600 text-contrast-green',
        },
        {
          id: '2',
          label: formatMessage({
            id: 'status.idle',
            defaultMessage: 'Inaktiv',
          }),
          value: 'idle',
          style: 'bg-background-400 text-text-800',
        },
        {
          id: '3',
          label: formatMessage({
            id: 'status.inactive',
            defaultMessage: 'Inaktiv',
          }),
          value: 'inactive',
          style: 'bg-background-400 text-text-800',
        },
        {
          id: '4',
          label: formatMessage({
            id: 'status.approved',
            defaultMessage: 'Godkänd',
          }),
          value: 'approved',
          style: 'bg-green-600 text-contrast-green',
        },
        {
          id: '5',
          label: formatMessage({
            id: 'status.rejected',
            defaultMessage: 'Ej godkänd',
          }),
          value: 'rejected',
          style: 'bg-background-400 text-contrast-gray',
        },
        {
          id: '6',
          label: formatMessage({
            id: 'status.submitted',
            defaultMessage: 'Inskickad',
          }),
          value: 'submitted',
          style: 'bg-red-600 text-contrast-red',
        },
        {
          id: '7',
          label: formatMessage({
            id: 'status.inactivating',
            defaultMessage: 'Inaktiveras',
          }),
          value: 'inactivating',
          style: 'bg-yellow-600 text-contrast-yellow',
        },
      ];

      return statusOptions.find((statusItem) => status == statusItem.value);
    },
    [formatMessage],
  );

  return getStatus;
};
